import Image from "next/image";
import Link from "next/link";
import { VideoData } from "../_hooks/useAboutVideos";
import { YouTubeIcon } from "./YouTubeIcon";

interface VideoCardProps {
  video: VideoData;
}

export function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      key={video.id}
      href={`https://www.youtube.com/watch?v=${video.id}`}
      target="_blank"
      className="flex flex-col justify-center gap-3"
    >
      <div className="relative aspect-video w-full overflow-hidden rounded-2xl">
        <Image
          src={video.thumbnail}
          alt={video.title}
          className="absolute w-full object-cover"
          fill
        />
      </div>
      <div className="flex w-full flex-col items-start justify-center gap-2">
        <Link
          href={`https://www.youtube.com/channel/${video.channelId}`}
          target="_blank"
          className="inline-flex items-center justify-start gap-2"
        >
          <YouTubeIcon />
          <div className="text-sm font-600">{video.channelTitle}</div>
        </Link>
        <p className="line-clamp-2 break-all text-base">{video.description}</p>
      </div>
    </Link>
  );
}
